var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('FolderGrid',{attrs:{"items":_vm.folders}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }